module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('image', {
    staticClass: "dylan_story",
    attrs: {
      "id": "panel1",
      "x": "120.5",
      "y": "53",
      "width": "926.829268",
      "height": "500",
      "href": "static/module_5/panel1.png"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b2db87b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_5/svg/characters/dylan_story/dylan_story_1.vue
// module id = 808
// module chunks = 1